export default "__VITE_ASSET__wJPVHaWQ__"